// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gi-0";